import { render, staticRenderFns } from "./temperature.vue?vue&type=template&id=fab83ba8&scoped=true"
import script from "./temperature.vue?vue&type=script&lang=js"
export * from "./temperature.vue?vue&type=script&lang=js"
import style0 from "./temperature.vue?vue&type=style&index=0&id=fab83ba8&prod&lang=scss&scoped=true"
import style1 from "./temperature.vue?vue&type=style&index=1&id=fab83ba8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab83ba8",
  null
  
)

export default component.exports